export default __webpack_public_path__ + "1aa22f82d408b48339280b269a38fd9f.gltf";